//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object TranslationsSetFieldsImpl_ResponseAdapter {
  public object TranslationsSetFields : Adapter<blazern.lexisoup.graphql.model.fragment.TranslationsSetFields> {
    public val RESPONSE_NAMES: List<String> =
        listOf("original", "translations", "translationsQualities")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): blazern.lexisoup.graphql.model.fragment.TranslationsSetFields {
      var _original: blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Original? = null
      var _translations: List<blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Translation>? = null
      var _translationsQualities: List<Int>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _original = Original.obj(true).fromJson(reader, customScalarAdapters)
          1 -> _translations = Translation.obj(true).list().fromJson(reader, customScalarAdapters)
          2 -> _translationsQualities = IntAdapter.list().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return blazern.lexisoup.graphql.model.fragment.TranslationsSetFields(
        original = _original ?: missingField(reader, "original"),
        translations = _translations ?: missingField(reader, "translations"),
        translationsQualities = _translationsQualities
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: blazern.lexisoup.graphql.model.fragment.TranslationsSetFields,
    ) {
      writer.name("original")
      Original.obj(true).toJson(writer, customScalarAdapters, value.original)

      writer.name("translations")
      Translation.obj(true).list().toJson(writer, customScalarAdapters, value.translations)

      writer.name("translationsQualities")
      IntAdapter.list().nullable().toJson(writer, customScalarAdapters, value.translationsQualities)
    }
  }

  public object Original : Adapter<blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Original> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Original {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _sentenceFields = blazern.lexisoup.graphql.model.fragment.SentenceFieldsImpl_ResponseAdapter.SentenceFields.fromJson(reader, customScalarAdapters)

      return blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Original(
        __typename = __typename ?: missingField(reader, "__typename"),
        sentenceFields = _sentenceFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Original,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      SentenceFieldsImpl_ResponseAdapter.SentenceFields.toJson(writer, customScalarAdapters, value.sentenceFields)
    }
  }

  public object Translation : Adapter<blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Translation> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Translation {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _sentenceFields = blazern.lexisoup.graphql.model.fragment.SentenceFieldsImpl_ResponseAdapter.SentenceFields.fromJson(reader, customScalarAdapters)

      return blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Translation(
        __typename = __typename ?: missingField(reader, "__typename"),
        sentenceFields = _sentenceFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: blazern.lexisoup.graphql.model.fragment.TranslationsSetFields.Translation,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      SentenceFieldsImpl_ResponseAdapter.SentenceFields.toJson(writer, customScalarAdapters, value.sentenceFields)
    }
  }
}
